export interface IAppointmentData {
  Id: string;
  owningResourceId: string;
  startTimeZoneId: string;
  endTimeZoneId: string;
  subject: string;
  description: string;
  patientId: number;
  physician: string;
  visitId: number;
  duration: string;
  owningCalendarId: string;
  alertMessage: string;
  location: string;
  locationId: number;
  note: string;
  reasonForReferal: string;
  unMappedProperties: string;
  status: string;
  VariantProperties: number;
  reCurrenceVersion: number;
  isOccurrenceDeleted: boolean;
  reminderEnabled: boolean;
  maxOccurrenceDateTime: Date;
  start: string;// Date;
  end: string;//Date;
  originalOccurrenceStart: Date;
  originalOccurrenceEnd: Date;
  reminderInterval: string;
  createdby: string;
  isLocked: boolean;
  isTimeZoneNeutral: boolean;
  isVisible: boolean;
  reminder: string;
  rootActivityId: string;
  recurrence: string;
  dbOperation: string;
  name: string;
  visitType: string;
  endTime: string;
  startTime: string;
  Date: string;
  usaDateFormate: string;
  roomName: string;
  roomId: string;
  reasonforReschedule: string;
  gender: string;
  action: string;
  patientPic: any;
  patientName: string;
  nurseName: string;
  encounterid: string;
  patEncStatus: string;
  dob: string;
  firstName: string;
  lastName: string;
  encStatus: number;
  visible: boolean;
  phyName: string;
  nurse: string;
  signOffStatus: string;
  appointmentTime: string;
  signOffNurse: string;
  checkOutPerson: string;
  statusColor: string;
  modifiedBy: string;
  modifiedOn: Date;
  //For Merge data
  appointmentCount: number;
  mergePatientId: number;
  txtColVisiblity: boolean;
  //Encounterselected type
  fromPatientboard: boolean;
  patientActive: boolean;
  problemCode: string;
  problemDesc: string;
  patSSN: string;
  medicationAllergies: string;
  patDOB: Date;
  resultStatus: string;
  resultValue: string;
  resultVisibility: string;
  labTestName: string;
  referralStatus: string;
  eType: string;
  reScheduleFlag: boolean;
  reScheduleAppId: string;
  insurance: string;
  checkedInDateTime: Date;
  checkedOutDateTime: Date;
  vitals: string;
  checkedInTime: string;
  checkedOutTime: string;
  checkedInOutTime: string;
  ProcedureName: string;
  appReminders: AppointmentNurseComments[];
  checkAuthorizeData: boolean;
  statusTooltipVisiblity: boolean;
  commentsTooltipVisiblity: boolean;
  insuranceStatus: string;
  payerType?: string;
  planName?: number;
  supervisorProvider: string;
  clinicTimeDurtion: number;
  receivedAmount: string;
  depositDate: string;
  cashAmount: string;
  chequeAmount: string;
  cardAmount: string;
  claimStatus: string;
  charges: string;
  procedureCodes: string;
  claimId: string;
  homePhone: string;
  cellPhone: string;
  workPhone: string;
  coPay: string;
  referralid: number;
  referralName: string;
  npiId: number;
  npiName: string;
  createdOn: Date;
  comments: string;
  facilityId: number;
  visitNote: number;
  orNote: number;
  orderNote: number;
  visitNoteStatus: string;
  orNoteStatus: string;
  visitCategory: string;
  pumpStatus: string;
  billingProvider: string;
  authId: number;
  procedureName: string;
  userId: string;
  role: string;
  reason: string;
  date: string;
  ctdayId: number;
  orderEncounterId: string;
  physicianLastFrstName: string;
  notesDetails: string;
  appStatus: string;
  screen: string;
  PPRequestId: number;
  appType: number;
  isProvider: boolean;
  isNurse: boolean;
  patientLink: string;
  providerLink: string;
  patEmail: string;
  patEncryptlink: string;
  provEncryptLink: string;
  gidId: string;
  dpatId: number;
  appointDate: string;
  isTele: boolean;
  patCellNo: string;
  appStartTime: string;
  patTeleSMS: string;
  isCallComplete: number,
  isCallWait: boolean,
  commentsOnly: string;
  locTwillioPhoneNum: string;
  careTeam?: string;
  visitCPTCode?: string;
  isSurgeryCenter?: string;
  IsOldPatient?:boolean;
  authorizationComments:string;
  eligibilityComments: string;
  eligibilityWorkStatusId:number;
  eligibilityWorkStatusName:string;
  authStatusId:number;
  workStatusName:string;
  professionalClaimStatus:string;
  institutionalClaimStatus:string;
}

export interface IAppointmentDataPB {
  Id: string;
  owningResourceId: string;
  startTimeZoneId: string;
  endTimeZoneId: string;
  subject: string;
  description: string;
  patientId: number;
  physician: string;
  visitId: number;
  duration: string;
  owningCalendarId: string;
  alertMessage: string;
  location: string;
  locationId: number;
  note: string;
  reasonForReferal: string;
  unMappedProperties: string;
  status: string;
  VariantProperties: number;
  reCurrenceVersion: number;
  isOccurrenceDeleted: boolean;
  reminderEnabled: boolean;
  maxOccurrenceDateTime: Date;
  start: string;// Date;
  end: string;//Date;
  originalOccurrenceStart: Date;
  originalOccurrenceEnd: Date;
  reminderInterval: string;
  createdby: string;
  isLocked: boolean;
  isTimeZoneNeutral: boolean;
  isVisible: boolean;
  reminder: string;
  rootActivityId: string;
  recurrence: string;
  dbOperation: string;
  name: string;
  visitType: string;
  endTime: string;
  startTime: string;
  Date: string;
  usaDateFormate: string;
  roomName: string;
  roomId: string;
  reasonforReschedule: string;
  gender: string;
  action: string;
  patientPic: any;
  patientName: string;
  nurseName: string;
  encounterid: string;
  patEncStatus: string;
  dob: string;
  firstName: string;
  lastName: string;
  encStatus: number;
  visible: boolean;
  phyName: string;
  nurse: string;
  signOffStatus: string;
  appointmentTime: string;
  signOffNurse: string;
  checkOutPerson: string;
  statusColor: string;
  modifiedBy: string;
  modifiedOn: Date;
  //For Merge data
  appointmentCount: number;
  mergePatientId: number;
  txtColVisiblity: boolean;
  //Encounterselected type
  fromPatientboard: boolean;
  patientActive: boolean;
  problemCode: string;
  problemDesc: string;
  patSSN: string;
  medicationAllergies: string;
  patDOB: Date;
  resultStatus: string;
  resultValue: string;
  resultVisibility: string;
  labTestName: string;
  referralStatus: string;
  eType: string;
  reScheduleFlag: boolean;
  reScheduleAppId: string;
  insurance: string;
  checkedInDateTime: Date;
  checkedOutDateTime: Date;
  vitals: string;
  checkedInTime: string;
  checkedOutTime: string;
  checkedInOutTime: string;
  ProcedureName: string;
  appReminders: AppointmentNurseComments[];
  checkAuthorizeData: boolean;
  statusTooltipVisiblity: boolean;
  commentsTooltipVisiblity: boolean;
  insuranceStatus: string;
  payerType?: string;
  planName?: number;
  supervisorProvider: string;
  clinicTimeDurtion: number;
  receivedAmount: string;
  depositDate: string;
  cashAmount: string;
  chequeAmount: string;
  cardAmount: string;
  claimStatus: string;
  charges: string;
  procedureCodes: string;
  claimId: string;
  homePhone: string;
  cellPhone: string;
  workPhone: string;
  coPay: string;
  referralid: number;
  referralName: string;
  npiId: number;
  npiName: string;
  createdOn: Date;
  comments: string;
  facilityId: number;
  visitNote: number;
  orNote: number;
  orderNote: number;
  visitNoteStatus: string;
  orNoteStatus: string;
  visitCategory: string;
  pumpStatus: string;
  billingProvider: string;
  authId: number;
  procedureName: string;
  userId: string;
  role: string;
  reason: string;
  date: string;
  ctdayId: number;
  orderEncounterId: string;
  physicianLastFrstName: string;
  notesDetails: string;
  appStatus: string;
  screen: string;
  dpatId: number;
  PPRequestId: number;
  appType: number;
  isProvider: boolean;
  isNurse: boolean;
  patientLink: string;
  providerLink: string;
  patEmail: string;
  patEncryptlink: string;
  provEncryptLink: string;
  gidId: string;
  //Date: string;
  appointDate: string;
  isTele: boolean;
  patCellNo: string;
  appStartTime: string;
  patTeleSMS: string;
  isCallComplete: number,
  isCallWait: boolean,
  commentsOnly: string;
  locTwillioPhoneNum: string;
  phiscalPhoneNum: string;
  patAppStatus?: number;
  IsOldPatient?:boolean;
  authorizationComments:string;
  eligibilityComments: string;
  eligibilityWorkStatusId:number;
  eligibilityWorkStatusName:string;
  authStatusId:number;
  workStatusName:string;
  professionalClaimStatus:string;
  institutionalClaimStatus:string;
  EncounterStatus_VisitNote?: string;
  EncounterStatus_OR?: string;
}

export interface AppointmentNurseComments {
  taskReminders: string;
}

export interface IAppointmentData2 {
  Id: string;
  owningResourceId: string;
  physician: string;
  visitId: number;
  duration: string;
  patientId: number;
  startTimeZoneId: string;
  endTimeZoneId: string;
  subject: string;
  description: string;
  owningCalendarId: string;
  locationId: number;
  note: string;
  comments: string;
  start: string; //Date;
  end: string; //Date;
  status: string;
  alertMessage: string;
  createdby: string;
  roomId: string;
  clinicTimeDurtion: number;
  supervisorProvider: string;
  reScheduleAppId: string;
  facilityId: number;
  billingProvider: string;
}
export class IAppointmentRemarks {
  codeId: number;
  code: string;
  color: string;
  remarks: string;
  isActive: boolean;
  createdBy: string;
  createdOn: Date;
  modifiedBy: string;
  modifiedOn: Date;
  checkd: boolean = false;
  dbOperation: string;
  facility: number;
  isInUse?: boolean;
  Appointmentid: string;
}

export class IExportexcelWorklist {
  appointmentTime: string;
  appointmentDate: string;
  patientName: string;
  patientID: number;
  patientPhoneno: string;
  visitType: string;
  providerName: string;
  location: string;
  remarks: string;
  reasonforvisit: string;
}

export class NextAppointment {
  appDate: string;
  appType: string;
}
export class IAppointmentStatusLogs {
  commentId?: number;
  appointmentId?: string;
  appStatus?: string;
  appDate?: string;
  providerName?: string;
  comments?: string;
  createdBy?: string;
  currentDate?: string;
  note?: string;
  reason?: string;
  commentTxt?: string;
  needtoUpdate?: number;
  displayComments?: string;
  createdDate?: string;
  location?: string
}

export class DayEndExelObj {
  ProviderName: string;
  AppTime: string;
  PatientName: string;
  Procedures: string;
  ApptStatus: string;
  Claim: string;
  ClaimStatus: string;
  EligibilityStatus:string;
  PaymentCollection: string;
  EligibilityComments:string;
  AuthorizationComments:string;
  AuthorizationStatus:string;
  Charged: string;
}
// Patient Board Appointments export (DownLoadPatientBoardAppointmentsFile) - mirrors the
// Patient Board grid columns, excluding App Type/Status/SMS/Call (those are UI-only action
// icons, not exportable data).
export class PBAppointmentExelObj {
  AppTime: string;
  PatientName: string;
  PatientID: string;
  VisitType: string;
  Remarks: string;
  Provider: string;
  Location: string;
  AppStatus: string;
  Room: string;
  PayerStatus: string;
  PayerType: string;
  PlanName: string;
  ReasonForVisit: string;
  Comments: string;
  EncounterStatusV: string;
  EncounterStatusOR: string;
  ClaimStatus: string;
  EligibilityStatus: string;
  EligibilityComments: string;
  AuthorizationStatus: string;
  AuthorizationComments: string;
}

export class IPAddressList {
  IPAddressId: number;
  IPAddresss: string;
  userId: string;
  locationId: number;
  facilityId: number;
  createdBy: string;
  createdOn: string;
}